import React, { useEffect, useState } from 'react';
import { Row, Col, Button, message, Space, Popconfirm } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProductMenus } from '../ducks/actions'
import { removeProductMenu, bulkRemoveProductMenus } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search'
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productMenus = useSelector((state) => state.product.productMenus);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'desc',
      key: 'desc',
      className: 'enable-click',
      sorter: true
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="product_menu"
          btnAction1={() => navigate(`/product/menu/${record.id}`)}
          recordId={record.id}
          onRemove={allowed([AllRoles.PRODUCT.MENU], 'delete') && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/product/menu/add');

  const btnList = [
    {
      title: t("Product.confirm_remove_select_product_menu"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("Product.new_menu")}`,
      classes: 'attendance-succes',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.productMenuListQuery) {
      dispatch(getProductMenus(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('productMenuListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.productMenuListQuery
      dispatch(getProductMenus(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      product_menu_id: id,
      status_event: 'remove'
    }

    await removeProductMenu(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Product.product_menu_remove_success"));
        setTimeout(() => dispatch(getProductMenus(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('productMenuListQuery', page, limit, '', '', searchVal, props.setLoading));
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      product_menus: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveProductMenus(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Product.product_menus_remove_success"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getProductMenus(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('productMenuListQuery', 1, limit, '', '', null, props.setLoading));
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getProductMenus(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('productMenuListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
    } else {
      dispatch(getProductMenus(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('productMenuListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        name: search.name,
        code: search.code
      };
      setSearchVal(searching);
      dispatch(getProductMenus(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('productMenuListQuery', 1, limit, '', '', searching, props.setLoading));
    } else {
      setSearchVal(null);
      dispatch(getProductMenus(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('productMenuListQuery', 1, limit, '', '', null, props.setLoading));
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
        navigate(`/product/menu/${record.id}`)
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("Product.product_menus")} btnList={allowed([AllRoles.PRODUCT.MENU], 'write') ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.productMenuListQuery?.searchValue}
            onRow={onClickRow}
            // listClass="nopad"
            ListData={productMenus?.list?.map(x => ({ ...x, key: x.id }))}
            ListCol={colName}
            rowSelection={rowSelection}
            onChange={onTableChange}
            pagination={{
              total: productMenus?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
    </>
  )
}